// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 * Per-entity counts in a source project (used by the project picker UI). Fields may be omitted when the source adapter cannot provide an exact count cheaply.
 * @export
 * @interface ExternalImportSourceProjectCounts
 */
export interface ExternalImportSourceProjectCounts {
  /**
   *
   * @type {number}
   * @memberof ExternalImportSourceProjectCounts
   */
  testCases?: number;
  /**
   *
   * @type {number}
   * @memberof ExternalImportSourceProjectCounts
   */
  testSets?: number;
  /**
   *
   * @type {number}
   * @memberof ExternalImportSourceProjectCounts
   */
  testPlans?: number;
  /**
   *
   * @type {number}
   * @memberof ExternalImportSourceProjectCounts
   */
  folders?: number;
  /**
   * Test cases in the source project that belong to no test plan. They are skipped unless the include_unlinked_test_cases option is enabled. Omitted when the source adapter cannot determine it
   * @type {number}
   * @memberof ExternalImportSourceProjectCounts
   */
  testCasesNotInPlan?: number;
}

export function ExternalImportSourceProjectCountsFromJSON(
  json: any
): ExternalImportSourceProjectCounts {
  return {
    testCases: !exists(json, "test_cases") ? undefined : json["test_cases"],
    testSets: !exists(json, "test_sets") ? undefined : json["test_sets"],
    testPlans: !exists(json, "test_plans") ? undefined : json["test_plans"],
    folders: !exists(json, "folders") ? undefined : json["folders"],
    testCasesNotInPlan: !exists(json, "test_cases_not_in_plan")
      ? undefined
      : json["test_cases_not_in_plan"],
  };
}

export function ExternalImportSourceProjectCountsToJSON(
  value?: ExternalImportSourceProjectCounts
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    test_cases: value.testCases,
    test_sets: value.testSets,
    test_plans: value.testPlans,
    folders: value.folders,
    test_cases_not_in_plan: value.testCasesNotInPlan,
  };
}
